export default __webpack_public_path__ + "static/media/Enhanced_anti-money_laundering.2824f176.png";